import "./typing-indicator.css";

import * as React from "react"
import { cn } from "@/lib/utils";

type TypingIndicatorProps = {
    isTyping: boolean
} & React.ComponentProps<"div">;

const TypingIndicator = ({ className, isTyping, ...props }: TypingIndicatorProps) => {
  return (
      <div
        className={cn(
          "bg-black border-black border-10 rounded-[1em] opacity-0 transition-[opacity,transform] duration-300 ease-in-out",
          isTyping && "opacity-100 -translate-y-2",
          className
        )}
      >
        <div className="flex items-center gap-1">
            <div className="h-[6px] w-[6px] rounded-full bg-white/60 animate-blink" />
            <div className="h-[6px] w-[6px] rounded-full bg-white/60 animate-blink delay-200" />
            <div className="h-[6px] w-[6px] rounded-full bg-white/60 animate-blink delay-400" />
        </div>
      </div>
  )
}

export { TypingIndicator };
export type { TypingIndicatorProps };

